<template>
  <div class="wallet-setting-list-container">
    <button
      class="wallet-setting-list-button"
      :style="`
        height: ${size || 40}px; width: ${size || 40}px;
        background-color: ${selected ? getColor('color-3') : '#0000'};
      `"
      v-ripple
      @click.prevent.stop="action
        ? $emit('actionClicked')
        : $emit('showChildren', identifier)"
    >
      <div
        v-if="value && value.colors && !icon"
        :class="`wallet-setting-list-selection-color`"
        :style="`background-color: ${getColor(value.colors[0])}`"
      />
      <TIcon
        v-else
        :name="getIcon()"
        color="white"
      />
    </button>
    <TransitionAccordion
      @nested-enter="show_content = true"
      @nested-leave="show_content = false"
    >
      <div
        v-if="show_children"
        class="wallet-setting-list-options"
      >
        <div v-for="index_x in options_length" :key="`key_1-${index_x-1}`">
          <TransitionFade v-for="index_y in Object.values(options).length" :key="`key_2-${index_y-1}`">
            <button
              v-if="Object.values(options)[index_y-1][index_x-1] && show_content"
              :key="`key_1-${index_x-1}x2-${index_y-1}`"
              :class="`
                wallet-setting-list-button-option
                ${isSelected(index_y-1, Object.values(options)[index_y-1][index_x-1])}
              `"
              :style="`height: ${size || 40}px; width: ${size || 40}px; transition-delay: ${index_x * 0.03}s`"
              v-ripple
              @click.prevent.stop="$emit('selectOption', {setting: Object.keys(options)[index_y-1], value: Object.values(options)[index_y-1][index_x-1].value})"
            >
              <!-- v-on:click.ctrl="$emit('button-clicked-strg', {setting: Object.keys(options)[index_y-1], value: Object.values(options)[index_y-1][index_x-1].value})" -->

              <div
                v-if="value.colors && !icon"
                :class="`wallet-setting-list-selection-color`"
                :style="`background-color: ${getColor(Object.values(options)[index_y-1][index_x-1].value)}`"
              />
              <!-- ${value.colors[0]} ${value.colors[0].includes('lighten') || value.colors[0].includes('darken')? '':'lighten-1'} -->
              <TIcon
                v-else-if="Object.values(options)[index_y-1][index_x-1].wp_icon"
                :name="getNewIcon(Object.values(options)[index_y-1][index_x-1].icon)"
              />
              <TIcon
                v-else-if="Object.values(options)[index_y-1][index_x-1].ticon"
                :name="Object.values(options)[index_y-1][index_x-1].ticon"
              />
              <TIcon
                v-else
                :name="Object.values(options)[index_y-1][index_x-1].icon"
              />
              <StandardBadge
                v-if="badge"
                :text="index_x"
                content_color="black"
              />
            </button>
            <div
              v-else-if="show_content"
              class="wallet-setting-list-button-option"
              :style="`height: ${size || 40}px; width: ${size || 40}px;`"
              :key="`key_1-${index_x-1}x2-${index_y-1}`"
            >
              <StandardBadge
                v-if="badge"
                :text="index_x"
                content_color="black"
              />
            </div>
          </TransitionFade>
        </div>
      </div>
    </TransitionAccordion>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';
import TransitionFade from '@/components/WorkPackageWIP/TransitionFade.component.vue';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    props: [
      'value',
      'options',
      'color',
      'icon',
      'size',
      'identifier',
      'show_children',
      // 'badge', // is passed without value
      // 'multiselect', // is passed without value
      // 'action', // is passed without value
    ],

    components: {
      TIcon,
      TransitionAccordion,
      TransitionFade,
      StandardBadge,
    },

    mixins: [
      TColor
    ],

    data: () => ({
      show_content: false,
    }),

    computed: {
      ...mapGetters('WorkPackage', [
        'getNewIcon',
        ],
      ),

      options_length() {
        let max_length = 0;
        for(let prop in this.options) {
          if (this.options[prop].length > max_length) {
            max_length = this.options[prop].length;
          }
        }
        return max_length;
      },

      action() {
        let a = this.$attrs;
        if(a.action !== undefined) {
          if(a.action || a.action === '')
            { return true; } }
        return false;
      },

      multiselect() {
        let a = this.$attrs;
        if(a.multiselect !== undefined) {
          if(a.multiselect || a.multiselect === '')
            { return true; } }
        return false;
      },

      badge() {
        let a = this.$attrs;
        if(a.badge !== undefined) {
          if(a.badge || a.badge === '')
            { return true; } }
        return false;
      },

      selected() {
        let a = this.$attrs;
        if(a.selected !== undefined) {
          if(a.selected || a.selected === '')
            { return true; } }
        return false;
      },
    },

    methods: {
      test() {
        console.log("!");
      },

      getIcon() {
        if(this.icon) {
          return this.icon;
        }
        else if (this.multiselect) {
          return this.getNewIcon(Object.values(this.options)[0].find(option => option.value === Object.values(this.value)[0][0]).icon);
        }
        else {
          if (this.value.value) {
            for (var i = 0; i < Object.values(this.options).length; i++) {
              for (var j = 0; j < Object.values(this.options)[i].length; j++) {
                if (Object.values(this.options)[i][j].value == this.value.value) {
                  return this.getNewIcon(Object.values(this.options)[i][j].icon);
                }
              }
            }
          }
          else {
            return this.getNewIcon(
              Object.values(this.options)[0].find(
                option => option.value === Object.values(this.value)[0]
              ).icon
            );
          }
        }
      },

      isSelected(index_y, option) {
        let found = false;
        for(let prop in this.options) {
          found = this.value[prop].find(item => item === option.value);
          if ((this.multiselect && !!found) || this.value[prop] === option.value) {
            if(this.selected) {
              return 'wallet-settings-list-button-option-highlight';
            }
          }
        }
        return '';
      },
    }
  }
</script>
<style>
.wallet-setting-list-container {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  transition: max-height 0.3s ease-in-out;
}
.wallet-setting-list-button, .wallet-setting-list-button-option {
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  overflow: visible;
}
.wallet-setting-list-button-option {
  border: 1px solid white;
  position: relative;
}
.wallet-settings-list-button-option-highlight {
  border: 3px solid white;
}
.wallet-setting-list-selection-color {
  height: 24px;
  width: 24px;
  border-radius: 50%;
}
.wallet-setting-list-options {
    flex-grow: 1;
    display: flex;
    flex-direction: row-reverse;
    grid-gap: 4px;
    padding-right: 8px;
    flex-wrap: wrap;
    overflow: visible;
}
</style>
